import React, { useState, useEffect, useCallback } from 'react';
import { MgmntSignDocCard } from '../../SignDoc/MgmntSignDocCard/MgmntSignDocCard';
import './DocumentRemovalAnimation.scss';

export const DocumentRemovalAnimation = ({ documentId, signDoc, tabContainerSelector = '.availableDocumentsContainer', documentIdPrefix = 'path-document-', onAnimationComplete }) => {
  const [animationState, setAnimationState] = useState({
    isAnimating: false,
    startPos: null,
    endPos: null,
    transitioning: false,
    currentSignDoc: null
  });
  
  // If the animation is running, we want to track this element
  const elemIdToTrack = documentId ? `${documentIdPrefix}${documentId}` : null;
  
  // Separate state to force re-renders
  const [isRunning, setIsRunning] = useState(false);
  
  // Start animation when props change
  useEffect(() => {
    if (documentId && signDoc) {
      startAnimation();
    }
  }, [documentId, signDoc]);
  
  const startAnimation = useCallback(() => {
    
    // Try to get DOM elements
    const docElement = document.getElementById(`${documentIdPrefix}${documentId}`);
    const tabContainer = document.querySelector(tabContainerSelector);
    
    
    if (docElement && tabContainer) {
      const docRect = docElement.getBoundingClientRect();
      const tabRect = tabContainer.getBoundingClientRect();
      
      setAnimationState({
        isAnimating: true,
        currentSignDoc: signDoc,
        startPos: {
          top: docRect.top,
          left: docRect.left,
          width: docRect.width,
          height: docRect.height
        },
        endPos: {
          top: tabRect.top + tabRect.height/2,
          left: tabRect.left + tabRect.width/2
        },
        transitioning: false
      });
      
      setIsRunning(true);
      
      // Start transition on next frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimationState(prev => ({...prev, transitioning: true}));
        });
      });
      
      // Complete animation
      setTimeout(() => {
        setAnimationState({
          isAnimating: false,
          startPos: null,
          endPos: null,
          transitioning: false,
          currentSignDoc: null
        });
        
        setIsRunning(false);
        
        if (onAnimationComplete) {
          onAnimationComplete();
        }
      }, 300);
    } else {
      if (onAnimationComplete) {
        onAnimationComplete();
      }
    }
  }, [documentId, signDoc, tabContainerSelector, documentIdPrefix, onAnimationComplete]);
  
  if (!animationState.isAnimating || !animationState.startPos || !animationState.endPos || !animationState.currentSignDoc) {
    return null;
  }
  
  return (
    <div
      className="document-removal-animation"
      data-transitioning={animationState.transitioning ? "true" : "false"}
      style={{
        top: animationState.startPos.top,
        left: animationState.startPos.left,
        width: animationState.startPos.width,
        height: animationState.startPos.height,
        transform: animationState.transitioning ?
          `translate(${animationState.endPos.left - animationState.startPos.left}px, 
           ${animationState.endPos.top - animationState.startPos.top}px) scale(0.5)` : 'none',
      }}
    >
      <MgmntSignDocCard
        signDoc={animationState.currentSignDoc}
        noButton={true}
      />
    </div>
  );
}; 